import { render } from "./Quotation.vue?vue&type=template&id=a463b88e"
import script from "./Quotation.vue?vue&type=script&lang=js"
export * from "./Quotation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david.haas/Documents/Projects/VSC/ommax-employer-branding-lp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__